<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ro22FJ/tc-custom/9781646567980.jpg?1723592038250" alt="This image is the cover for the book Leap of Faith"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Leap of Faith
      </h1>
      <p class="bookDescription body article font2">
        <p>Abseiling? How did Anika persuade her to do that? When Lauren set out to start her life over -- new job, new city, new friends -- she never dreamed she’d be clinging to a rope, dangling off a ninety-foot railway viaduct. Then again, she’d never expected to meet someone like Anika.<br/><br/>Determined to rebuild her confidence and regain independence after the devastation of a shattering break-up, Lauren was surprised to be drawn to Anika. Headstrong and daring, Anika was fascinating and yet, intimidating -- not Lauren’s usual type. Their unexpected friendship was like a breath of fresh air ... Could it be more? With the painful past still raw, was it too soon to love again? Was Lauren merely rebounding?<br/><br/>In the midst of bravely tackling the challenging abseil, Lauren had a decision to make. Play safe or throw caution to the wind? Is she prepared to take a leap of faith?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mags Hayward
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c6c3428